export default __webpack_public_path__ + "static/media/background-image.2f2016e7.jpg";